<template>
    <div class="vue-balloon">
        <svg id="a" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 132.99 169.23">
            <path
                d="m122.32,22.56C112.91,8.74,95.8.22,66.33,0l-.02,2.06-.02-2.06C36.77.22,19.66,8.74,10.27,22.56,1.12,36.02,0,53.6,0,70.06c0,13.58.22,27.96,5.39,40.03,5.21,12.16,15.26,21.56,33.49,26.26l21.35,29.67,3.24-2.33h0s0,0,0,0l-3.23,2.32h0s0,.03,0,.03c.67.92,1.54,1.68,2.54,2.23,1,.55,2.11.87,3.24.95l.26-3.98h0s-.26,3.98-.26,3.98l.24.02h.24c1.16-.07,2.29-.4,3.31-.95,1.02-.56,1.9-1.34,2.57-2.29l.74-1.04v-.03c.38-.53.89-1.25,1.53-2.14,1.42-1.97,3.4-4.72,5.65-7.83,4.21-5.82,9.33-12.9,13.44-18.61,18.23-4.64,28.29-14.05,33.5-26.22,5.17-12.08,5.39-26.49,5.39-40.07,0-16.47-1.15-34.04-10.31-47.5Z"
                style="fill:#fff;"/>
            <path
                d="m66.33,3.99C8.75,4.41,3.99,37.05,3.99,70.06c0,27.43,1.08,54.19,37.29,62.79l22.19,30.83c.33.45.75.82,1.24,1.09.49.27,1.03.43,1.59.46.56-.03,1.1-.18,1.6-.45.49-.27.91-.65,1.24-1.1,0-.14,13.77-19.08,22.22-30.83,36.21-8.49,37.29-35.36,37.29-62.79,0-33.01-4.87-65.65-62.34-66.08"
                style="fill:#ed702a;"/>
            <rect width="132.99" height="132.99" style="fill:none;"/>
        </svg>
        <p>
            <slot></slot>
        </p>
    </div>
</template>

<script>
export default {
    name: "Balloon"
}
</script>